import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Monitor, ChefHat, LayoutDashboard, ArrowLeftRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const StaffSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const systems = [
    {
      id: 'pos',
      title: 'POS',
      icon: Monitor,
      path: '/pos',
      color: 'bg-[#00E5FF]',
      hoverColor: 'hover:bg-[#00B8D4]'
    },
    {
      id: 'kitchen',
      title: 'Kitchen',
      icon: ChefHat,
      path: '/kitchen',
      color: 'bg-[#00C853]',
      hoverColor: 'hover:bg-[#00E676]'
    },
    {
      id: 'admin',
      title: 'Admin',
      icon: LayoutDashboard,
      path: '/admin',
      color: 'bg-[#FFD600]',
      hoverColor: 'hover:bg-[#FFEA00]'
    }
  ];

  // Filter out current page
  const otherSystems = systems.filter(s => s.path !== location.pathname);
  const currentSystem = systems.find(s => s.path === location.pathname);

  const handleSwitch = (path) => {
    setIsOpen(false);
    navigate(path);
  };

  return (
    <div className="fixed bottom-20 right-6 z-[100] sm:bottom-6">
      {/* Backdrop when open */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/30 z-[99]" 
          onClick={() => setIsOpen(false)}
        />
      )}
      
      {/* Menu Container */}
      <div className="relative z-[100] flex flex-col-reverse items-end gap-3">
        {/* Other system buttons - shown when open */}
        {isOpen && (
          <div className="flex flex-col gap-2 mb-2">
            {otherSystems.map((system) => {
              const Icon = system.icon;
              return (
                <Button
                  key={system.id}
                  onClick={() => handleSwitch(system.path)}
                  className={`${system.color} ${system.hoverColor} text-black font-semibold shadow-xl h-12 px-5 rounded-full transition-all transform hover:scale-105`}
                  data-testid={`switch-to-${system.id}`}
                >
                  <Icon className="w-5 h-5 mr-2" strokeWidth={2} />
                  {system.title}
                </Button>
              );
            })}
          </div>
        )}

        {/* Main toggle button */}
        <Button
          onClick={() => setIsOpen(!isOpen)}
          className={`${isOpen ? 'bg-gray-700 hover:bg-gray-600 rotate-0' : 'bg-[#FF4500] hover:bg-[#FF5722]'} text-white shadow-xl h-14 w-14 rounded-full p-0 transition-all duration-200`}
          data-testid="staff-switcher-toggle"
        >
          {isOpen ? (
            <X className="w-6 h-6" />
          ) : (
            <ArrowLeftRight className="w-6 h-6" />
          )}
        </Button>

        {/* Current system indicator dot */}
        {!isOpen && currentSystem && (
          <div className={`absolute top-0 right-0 w-4 h-4 ${currentSystem.color} rounded-full border-2 border-[#050505] shadow-md`} />
        )}
      </div>
    </div>
  );
};

export default StaffSwitcher;
